import React, { useState } from "react";
import "./PopeyeContent.scss";
import PopeyeShipmentList from "../../PopeyeShipmentList/PopeyeShipmentList";
import PopeyeShipmentUpdate from "../../PopeyeShipmentUpdate/PopeyeShipmentUpdate";

const PopeyeContent = ({ shipments = [] }) => {
  const hasShipments = shipments && shipments.length > 0;
  const [selectedShipment, setSelectedShipment] = useState(null);

  return (
    <div className="PopeyeContent">
      {hasShipments ? (
        <>
          <PopeyeShipmentUpdate selectedShipment={selectedShipment} />
          <PopeyeShipmentList shipments={shipments} setSelectedShipment={setSelectedShipment} />
        </>
      ) : (
        <div className="no-shipments-message">
          <p>No shipments available at the moment. Please check back later.</p>
        </div>
      )}
    </div>
  );
};

export default PopeyeContent;
